// extracted by mini-css-extract-plugin
export default {"ActionBtn":"QW02m8d_","sizeS":"OPX3AhZa","sizeM":"Af8L_hWv","navy":"jfK_5czJ","Spinner":"TyBxPesz","isBusy":"V78UwhuT"};